import { useEffect, useState } from "react";
import { SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { NotifType } from "./Notification.type";
import { INotificationProps } from "./Notification.interface";
import { Styles } from "./Notification.styles";
import { REMOVE_NOTIFICATION, TIMEOUT_LOW } from "../shared/constant";

const Notification = ({ type, message, timeout, dispatch, id }: INotificationProps) => {
  const [show, setShow] = useState(false);

  const closeNotif = () => {
    setShow(false);
    dispatch({
      type: REMOVE_NOTIFICATION,
      id: id,
    });
  };

  const getMessageBarIntent = (type: NotifType): "success" | "error" | "info" | "warning" => {
    switch (type) {
      case "SUCCESS":
        return "success";
      case "ERROR":
        return "error";
      case "INFO":
        return "info";
      case "WARNING":
        return "warning";
      default:
        return "info";
    }
  };

  useEffect(() => {
    setShow(true);

    if (timeout) {
      setTimeout(() => {
        closeNotif();
      }, timeout);
    } else {
      setTimeout(() => {
        closeNotif();
      }, TIMEOUT_LOW);
    }
  }, []);

  const intent = getMessageBarIntent(type);
  const bgColor = Styles.getBackgroundColor(intent);

  return (
    <>
      {show && (
        <div
          style={{
            zIndex: 300,
            backgroundColor: bgColor,
            padding: "2px 0px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            pointerEvents: "auto",
          }}
        >
          <SkyMessageBar
            intent={intent}
            message={message}
            onDismiss={closeNotif}
          />
        </div>
      )}
    </>
  );
};

export default Notification;
